import { LocaledText as API } from '@src/api/types';
import { Translations as Data } from '@src/types';

const Factory = (api: API[] | null = []): Data => {
  return api
    ? api.reduce<Data>((acc, cur) => {
        acc[cur.language.toLowerCase()] = cur.text;
        return acc;
      }, {})
    : {};
};

export default Factory;
